import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { PerfilSeccionId } from '../../data/perfil-microempresario.content';
import { PerfilSeccionAccesoService } from './perfil-seccion-acceso.service';

function seccionFromUrl(url: string): PerfilSeccionId | null {
  if (url.includes('/perfil/sobre-ingresos')) {
    return 'sobre-ingresos';
  }
  if (url.includes('/perfil/sobre-negocio')) {
    return 'sobre-negocio';
  }
  if (url.includes('/perfil/sobre-ti')) {
    return 'sobre-ti';
  }
  return null;
}

/**
 * Bloqueo secuencial también por URL:
 * Sobre ti libre → negocio solo si ti está completo → ingresos solo si negocio está completo.
 */
export const perfilSeccionGuard: CanActivateFn = (
  _route,
  state
): Observable<boolean | UrlTree> | boolean | UrlTree => {
  const acceso = inject(PerfilSeccionAccesoService);
  const router = inject(Router);
  const seccionId = seccionFromUrl(state.url);
  if (!seccionId || seccionId === 'sobre-ti') {
    return true;
  }

  return acceso.ensureFromSolicitud().pipe(
    map(() => {
      if (acceso.canAccess(seccionId)) {
        return true;
      }
      return router.parseUrl(acceso.firstBlockedRedirectUrl());
    }),
    catchError(() => of(router.parseUrl(acceso.firstBlockedRedirectUrl())))
  );
};
